import React, { useEffect, useState } from 'react';
import FalconComponentCard from 'components/common/FalconComponentCard';
import dayjs from 'dayjs';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import { LineChart } from 'echarts/charts';
import {
  GridComponent,
  LegendComponent,
  TitleComponent,
  TooltipComponent
} from 'echarts/components';
import * as echarts from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { tooltipFormatter } from 'helpers/echart-utils';
import { useAppContext } from 'providers/AppProvider';
import {
  getReportAll
  // getReportDaily,
  // getReportDownloadAll
} from 'nursd-dashboard/api/report';
import { useAuth } from 'nursd-dashboard/context/AuthContext';

echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  LineChart,
  CanvasRenderer,
  LegendComponent
]);

const LineGradientChart = () => {
  const getDatesForNextTwoMonths = () => {
    const result = [];
    const currentDate = new Date();
    const futureDate = new Date();
    futureDate.setMonth(currentDate.getMonth() + 2);
    futureDate.setDate(futureDate.getDate() - 1);

    while (currentDate <= futureDate) {
      const min = Math.round(Math.random() * 9 + 1) * 10; // Random Min value rounded to nearest ten
      const max = min + Math.round(Math.random() * 10) * 10; // Random Max value greater than Min, rounded to nearest ten
      const value = Math.round((Math.random() * (max - min) + min) / 10) * 10; // Random Value between Min and Max, rounded to nearest ten

      result.push([currentDate.toISOString().split('T')[0], min, value, max]);
      currentDate.setDate(currentDate.getDate() + 1);
    }

    return result;
  };
  const { authToken } = useAuth();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  // const [date, setDate] = useState('');
  // const [downloadData, setDownloadData] = useState(undefined);
  // const [loadingBar, setLoadingBar] = useState(false);
  // const [dataBar, setDataBar] = useState(undefined);
  // const [change, setChange] = useState(false);
  const change = false;

  // console.log(data);

  const getReport = async () => {
    await getReportAll(authToken)
      .then(res => {
        if (res) {
          if (change) {
            const datesArray = getDatesForNextTwoMonths();
            setData([
              // ['Date', 'Posted', 'Accepted', 'Max Allowed'],
              ...datesArray
            ]);
          } else {
            const finalResult = [
              ['2024-09-01', 110, 75, 210],
              ['2024-09-02', 100, 145, 195],
              ['2024-09-03', 95, 0, 175],
              ['2024-09-04', 130, 90, 220],
              ['2024-09-05', 120, 110, 205],
              ['2024-09-06', 140, 85, 230],
              ['2024-09-07', 105, 70, 180],
              ['2024-09-08', 115, 100, 200],
              ['2024-09-09', 125, 130, 215],
              ['2024-09-10', 135, 120, 225]
            ];
            setData(finalResult);
          }
          setLoading(false);
        }
      })
      .catch(e => {
        console.log(e);
      });
  };

  useEffect(() => {
    getReport();
  }, [authToken, change]);

  const chartCode = `function ChartOptions() {
    const { getThemeColor } = useAppContext();
  
    const data = ${JSON.stringify(data)};
    
    const dateList = data.map(function (item) {
      return item[0];
    });
    
    const valueList1 = data.map(function (item) {
      return item[1];
    });

    const valueList2 = data.map(function (item) {
      return item[2];
    });

    const valueList3 = data.map(function (item) {
      return item[3];
    });

    const handleChartClick = params => {
    if (params.componentType === 'series') {
    }
  };
    
    const getOption = () => ({
    visualMap: {
        show: false,
        type: 'continuous',
        dimension: 0,
        min: 0,
        max: dateList.length - 1,
        color: [getThemeColor('danger'), getThemeColor('warning')]
      },
      tooltip: {
        trigger: 'axis',
        padding: [7, 10],
        backgroundColor: getThemeColor('gray-100'),
        borderColor: getThemeColor('gray-300'),
        textStyle: { color: getThemeColor('gray-1100') },
        borderWidth: 1,
        transitionDuration: 0,
        axisPointer: {
          type: 'none'
        },
        formatter: tooltipFormatter
      },
      xAxis: {
        type: 'category',
        data: dateList,
        axisLabel: {
          formatter: value => dayjs(value).format('MMM DD'),
          color: getThemeColor('gray-500'),
          margin: 15
        },
        axisLine: {
          lineStyle: {
            color: getThemeColor('gray-300'),
            type: 'solid'
          }
        },
        axisPointer: {
          lineStyle: {
            color: getThemeColor('gray-300')
          }
        }
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          show: true,
          color: getThemeColor('gray-500'),
          margin: 15
        },
        splitLine: {
          lineStyle: {
            color: getThemeColor('gray-200'),
            type: 'dashed'
          }
        }
      },
      grid: { right: '3%', left: '8%', bottom: '10%', top: '5%' },
      series: [
        {
          name: 'Minimum',
          type: 'line',
          showSymbol: false,
          symbolSize: 10,
          symbol: 'circle',
          data: valueList1,
          itemStyle: {
            color: getThemeColor('primary'),
            borderWidth: 2,
            borderColor: getThemeColor('primary')
          },
          lineStyle: {
          color: getThemeColor('primary'),
          width: 2
          }
        },
        {
          name: 'Accepted',
          type: 'line',
          showSymbol: false,
          symbolSize: 10,
          symbol: 'circle',
          data: valueList2,
          itemStyle: {
            color: getThemeColor('success'),
            borderWidth: 2,
            borderColor: getThemeColor('success')
          },
          lineStyle: {
          color: getThemeColor('success'),
          width: 2
          }
        },
        {
          name: 'Maximum',
          type: 'line',
          showSymbol: false,
          symbolSize: 10,
          symbol: 'circle',
          data: valueList3,
          itemStyle: {
            color: getThemeColor('danger'),
            borderWidth: 2,
            borderColor: getThemeColor('danger')
          },
          lineStyle: {
          color: getThemeColor('danger'),
          width: 2
          }
        }
      ]
  });
    return (
      <ReactEChartsCore
        echarts={echarts}
        option={getOption()}
        onEvents={{
          click: handleChartClick
        }}
        style={{ height: '18.75rem' }}
      />
    );
  }
  `;

  console.log(authToken);

  return (
    <>
      {loading ? (
        <FalconComponentCard>
          <FalconComponentCard.Header title="Bid Report" light={false} />
          <p className="m-5">Loading...</p>
        </FalconComponentCard>
      ) : (
        <FalconComponentCard>
          <h5 className="m-3">Bid Report</h5>
          {/* <FalconComponentCard.Header title="Bid Report" light={false} /> */}
          <FalconComponentCard.Body
            code={chartCode}
            language="jsx"
            scope={{
              ReactEChartsCore,
              echarts,
              useAppContext,
              dayjs,
              tooltipFormatter
            }}
          />
        </FalconComponentCard>
      )}
    </>
  );
};

export default LineGradientChart;
